import FaqSection from '@/v2/components/sections/common/faq-section'
import ForWhoSection from '@/v2/components/sections/common/for-who-section'
import HelperSection from '@/v2/components/sections/common/helper-section'
import PopularDestinationsSection from '@/v2/components/sections/common/popular-destinations-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSection from '@/v2/components/sections/common/service-tips-section'
import HeroSection from '@/v2/components/sections/snowboard-shipping/hero-section'
import HowServicesWorkSection from '@/v2/components/sections/snowboard-shipping/how-services-work-section'

import {
  benefitsSectionContent,
  faqSectionContent,
  helperSectionContent,
  heroSectionContent,
  howOurSnowboardShippingServiceWorksSectionContent,
  popularDestinationsSectionContent,
  promotionalBannerSectionContent,
  whyWeSectionContent
} from '@/v2/constants/pages/public-pages/snowboard-shipping-page'

interface SnowboardShippingPageProps {}

const SnowboardShippingPage: React.FC<SnowboardShippingPageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        img1ClassName='xl-min:!w-[475.22px] xl-min:!h-[529px] lg-mn:w-[196px] lg-mn:h-[219px] md-mn:w-[162px] md-mn:h-[181px] md-mn:block hidden'
        img2ClassName='xl-min:!w-[463px] xl-min:!h-[378px] lg-mn:w-[198px] lg-mn:h-[219px] md-mn:w-[164px] md-mn:h-[134px] md-mn:block hidden'
        btnClassName='xl-min:w-[279px] md-mn:w-[240px] w-[278px] xl-min:h-[60px] h-[44px]'
      />
      <ServiceTipsSection
        isBgDark
        {...whyWeSectionContent}
        className='[&_article]:bg-white [&_article:hover]:shadow-md [&_article_img]:w-[100px] [&>div>div]:gap-1'
        sectionTitleClassName='w-full'
      />
      <HowServicesWorkSection
        {...howOurSnowboardShippingServiceWorksSectionContent}
        className={`
        xl-min:[&_button]:!w-[278px]
        md-mn:[&_button]:w-[240px]
        [&_button]:w-[246px]
        `}
      />
      <HelperSection isBgDark {...helperSectionContent} sectionTitleClassName='w-full' />
      <ForWhoSection
        {...benefitsSectionContent}
        className='xl-min:[&_article]:flex-row [&_article]:flex-col xl-min:[&_article]:text-left [&_article]:text-center xl-min:[&_div_div]:!grid-cols-2'
        imgClassName='xl-min:w-[425px] xl-min:h-[239px] w-[354px] h-[199px]'
      />
      <PopularDestinationsSection
        isBgDark
        {...popularDestinationsSectionContent}
        sectionTitleClassName='xl-min:!max-w-full md-mn:max-w-[598px] xl-min:[&_p]:w-full md-mn:[&_p]:w-[80%]'
      />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        className={`
          md-mn:[&_article]:flex-row-reverse 
          xl-min:[&_article]:h-auto
          xl-min:[&_button]:w-[228.32px]
          md-mn:[&_button]:w-[242.51px]
          [&_button]:w-[230px]
          `}
        imgClassName='xl-min:w-[675px] xl-min:h-[480px] w-[337.5px] h-[240px]'
      />
      <FaqSection isBgDark {...faqSectionContent} />
    </>
  )
}

export default SnowboardShippingPage
